/** @type {EventListener} */
export const clickOnEnter = (event) => {
  if (event.keyCode === 13) {
    event.target.click();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
  }
};

/** @type {EventListener} */
export const clickOnLink = (event) => {
  if (event.keyCode === 13 || event.keyCode === 32) {
    event.target.click();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
  }
};

export const listBoxHandler = (id) => {
  const listBoxContainer = document.getElementById(id);
  if (!listBoxContainer) return null;

  listBoxContainer.setAttribute("tabindex", 0);
  listBoxContainer.setAttribute("role", "listbox");
  listBoxContainer.removeAttribute("aria-activedescendant");

  const listItems = listBoxContainer.getElementsByTagName("li");

  for (let i = 0; i < listItems.length; i++) {
    const listItem = listItems[i];
    listItem.setAttribute("tabindex", -1);
    listItem.setAttribute("role", "option");
    listItem.setAttribute("id", `${id}-${i}`);
    listItem.setAttribute("aria-selected", false);
  }

  const focusToItem = (item, current) => {
    item.focus();
    item.setAttribute("aria-selected", true);
    item.setAttribute("tabindex", 0);
    listBoxContainer.setAttribute(
      "aria-activedescendant",
      item.getAttribute("id")
    );
    if (current) {
      current.setAttribute('tabindex', -1);
      current.setAttribute("aria-selected", false);
    }
  }

  const handleNavigation = (e) => {
    const currentItem =
      listBoxContainer.querySelector("[aria-selected=true]") || listItems[0];
    if (!currentItem) return;

    switch (e.keyCode) {
      case 9: // TAB
        break;
      case 36: // home
        if (listItems[0]) {
          focusToItem(listItems[0], currentItem);
          e.preventDefault();
        }
        break;
      case 35: // end
        const lastIndex = listItems.length - 1;
        if (listItems[lastIndex]) {
          focusToItem(listItems[lastIndex], currentItem);
          e.preventDefault();
        }
        break;
      case 38: // Up arrow
        if (currentItem.previousSibling) {
          focusToItem(currentItem.previousSibling, currentItem);
          e.preventDefault();
        }
        break;
      case 40: // Down
        if (currentItem.nextSibling) {
          focusToItem(currentItem.nextSibling, currentItem);
          e.preventDefault();
        }
        break;
      default:
        // TODO: focus on searched option
        break;
    }
  };

  const initFocus = () => {
    const currentItem =
      listBoxContainer.querySelector("[aria-selected=true]") || listItems[0];
    if (!currentItem) return;
    focusToItem(currentItem);
    listBoxContainer.setAttribute("tabindex", -1);
  };

  listBoxContainer.addEventListener("keydown", handleNavigation);
  listBoxContainer.addEventListener("focus", initFocus);

  return () => {
    listBoxContainer.removeEventListener("keydown", handleNavigation);
    listBoxContainer.removeEventListener("focus", initFocus);
  };
};



// WEBPACK FOOTER //
// ./utils/eventHandlers.js